import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/brand/brand/apps/docs/node_modules/@primer/gatsby-theme-doctocat/src/components/layout.js";
import CustomVideoPlayer from '../../../src/components/custom-video-player';
import ComponentLayout from '../../../src/layouts/component-layout';
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const DoDontContainer = makeShortcode("DoDontContainer");
const Do = makeShortcode("Do");
const Caption = makeShortcode("Caption");
const Dont = makeShortcode("Dont");
const layoutProps = {
  _frontmatter
};
const MDXLayout = ComponentLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">




    <h2>{`Anatomy`}</h2>
    <p><img parentName="p" {...{
        "src": "https://github.com/primer/brand/assets/13340707/1a5e494f-7bd3-497c-933c-6c809a78422c",
        "alt": "A complete logo suite component, featuring a heading, description and two rows of 6 vendor logos in their default muted colors"
      }}></img></p>
    <ul>
      <li parentName="ul"><strong parentName="li">{`Heading:`}</strong>{` an optional main title of the logo suite.`}</li>
      <li parentName="ul"><strong parentName="li">{`Description:`}</strong>{` optional information that describes the logos shown.`}</li>
      <li parentName="ul"><strong parentName="li">{`Logobar:`}</strong>{` a space for a list of logos, with three appearance options.`}</li>
      <li parentName="ul"><strong parentName="li">{`Divider:`}</strong>{` an optional divider to separate the logo suite from following content.`}</li>
    </ul>
    <h2>{`Usage`}</h2>
    <p>{`Use the logo suite component to showcase a list of logos, such as for clients, sponsors, or related enterprises.`}</p>
    <p>{`A logo suite is intended to build credibility, trust, and provide social proof by displaying consistent logos.`}</p>
    <p>{`Logo suite should be used for groups of logos more than 4 and less than 12. In scenarios hoping to showcase more than 12 logos, considering stacking two components together. To create the best visual consistency and balance, rearrange and resize the logos when necessary to create similar area distribution and attention to each of the logos.`}</p>
    <h3>{`Arrangement`}</h3>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/131988618/da2bd3f3-c7d8-4880-b30d-c05dd4897ba6" alt="" />
    <Caption mdxType="Caption">
      Arrange the logos so that the sizes, heights, colors, and areas of the
      separate logos create consistency and balance.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/13340707/d7ac28ec-e341-4d77-8220-fd4197d5613b" alt="" />
    <Caption mdxType="Caption">
      Don’t place logos without considering the spatial balance of the logo
      suite. Rearrange the logos to prevent using more than two rows or
      imbalance.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Contextual information`}</h3>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/131988618/79680b75-9e3b-4eb1-9371-2d8ee45a6dc1" alt="" />
    <Caption mdxType="Caption">
      Do publish the logo suite with context. Introduce the logos and, when
      applicable, share how the logos have been grouped together.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/131988618/5ab14ace-9c9e-425f-8b5c-73de82340733" alt="" />
    <Caption mdxType="Caption">
      Don’t use the logo suite without a heading/description. Consider turning
      off a visible description if needed.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h3>{`Color uniformity`}</h3>
    <DoDontContainer stacked mdxType="DoDontContainer">
  <Do mdxType="Do">
    <img src="https://github.com/primer/brand/assets/13340707/b7126430-0d81-4fb6-bd7d-8f35cff923dd" alt="" />
    <Caption mdxType="Caption">
      Ensure that the colors are consistent across the logos to match the logo
      bar option. Ensure spacing between logos are consistent.
    </Caption>
  </Do>
  <Dont mdxType="Dont">
    <img src="https://github.com/primer/brand/assets/13340707/85f477d5-9c3d-4db3-847c-1bcf3539ab67" alt="" />
    <Caption mdxType="Caption">
      Don’t use logos with inconsistent colors or don’t match the logo bar
      option. Don’t use inconsistent spacing.
    </Caption>
  </Dont>
    </DoDontContainer>
    <h2>{`Options`}</h2>
    <h3>{`Logo bar appearance`}</h3>
    <p>{`The logo suite offers three appearance options:`}</p>
    <ul>
      <li parentName="ul"><inlineCode parentName="li">{`muted`}</inlineCode>{`: The muted option is suitable for displaying 6+ logos and displays logos in a `}<inlineCode parentName="li">{`secondary`}</inlineCode>{` color. It allows for two rows of logos, maintaining a clean and organized appearance.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`emphasis`}</inlineCode>{`: The emphasis option is designed for spotlighting ~5 logos in the `}<inlineCode parentName="li">{`primary`}</inlineCode>{` color. It displays logos larger, drawing more attention to the logos.`}</li>
      <li parentName="ul"><inlineCode parentName="li">{`marquee`}</inlineCode>{`: The marquee option provides a flowing logo animation and can accommodate up to 12 logos. It is ideal for scenarios with limited page real estate.`}</li>
    </ul>
    <p>{`All three options on the logo bar contains an optional divider. This divider can serve as a visual separator. These three options can be used adjacently.`}</p>
    <div>
  <img src="https://github.com/primer/brand/assets/131988618/d525e6b1-bf67-4684-9300-401ef7686b47" alt="" />
  <Caption mdxType="Caption">
    Use the default muted option when displaying 6-12 logos across two rows. 2
    rows (when using 6-12 logos).
  </Caption>
    </div>
    <div>
  <img src="https://github.com/primer/brand/assets/131988618/ce3e22f1-9852-4869-830b-5d54b6a1a039" alt="" />
  <Caption mdxType="Caption">
    The emphasis option can be used to spotlight logos. It is best used with 6
    or less logos to create 1 row.
  </Caption>
    </div>
    <div>
  <img src="https://github.com/primer/brand/assets/131988618/409d7a90-d086-438b-80ab-31350f6c42fa" alt="" />
  <Caption mdxType="Caption">The marquee options allows for different speed options.</Caption>
    </div>
    <h3>{`Alignment`}</h3>
    <p>{`The logo suite comes with start and center align options. Only the heading and description will have visible changes to their alignment as logos will be consistently center aligned to create balance. By default, the logo suite is aligned to the start of the page.`}</p>
    <h2>{`Accessibility`}</h2>
    <p>{`Always ensure that a heading is provided to the logo suite. Headings provide leading context to the logos shown, and serve as a navigation hook for assistive technologies. It can be visually hidden if needed.`}</p>
    <h2>{`Related components`}</h2>
    <ul>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/Image"
        }}>{`Image`}</a>{`: to display a graphical representation.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/OrderedList"
        }}>{`Ordered List`}</a>{`: to display a list of numbered items.`}</li>
      <li parentName="ul"><a parentName="li" {...{
          "href": "/components/UnorderedList"
        }}>{`Unordered List`}</a>{`: to present a collection of items without specific ordering.`}</li>
    </ul>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      